<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Direct Booking'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <tidy-image
            [src]="'assets/svg/globe-outline.svg'"
            class="header-size" />
          <tidy-text [header]="'Site Details'" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text [helper]="'Property'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="config.property_name"
            [translate]="false" />
        </tidy-row>
        <tidy-divider />
        <tidy-row class="extra-top-padding">
          <tidy-text [helper]="'Template'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="config.template"
            [translate]="false" />
        </tidy-row>
        <tidy-divider />
        <tidy-row class="extra-top-padding">
          <tidy-text [helper]="'Default URL'" />
        </tidy-row>
        <tidy-row>
          <tidy-image
            [src]="'assets/svg/link-outline.svg'"
            class="body-size" />
          <tidy-text
            [body]="config.site_url"
            [translate]="false" />
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row>
          <tidy-image
            [src]="'assets/svg/link-outline.svg'"
            class="header-size" />
          <tidy-text [header]="'Custom Domain'" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text [helper]="'Point your own domain to this booking site. Add a CNAME record at your DNS provider pointing to x.tidy.com.'" />
        </tidy-row>

        <form [formGroup]="form" novalidate>
          <tidy-row class="extra-top-padding">
            <tidy-input
              [label]="'Custom Domain'"
              formControlName="customDomain"
              [form]="form.controls.customDomain"
              [icon]="'assets/svg/globe-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid domain (e.g. book.yourdomain.com)'" />
          </tidy-row>
        </form>

        <tidy-alert class="extra-top-padding">
          <tidy-row>
            <tidy-text [helper]="'DNS Configuration'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'1. Log in to your domain registrar (GoDaddy, Namecheap, Cloudflare, etc.)'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'2. Add a CNAME record:'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'&nbsp;&nbsp;&nbsp;&nbsp;Host: your subdomain (e.g. book)'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'&nbsp;&nbsp;&nbsp;&nbsp;Points to: x.tidy.com'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'3. Save and wait for DNS propagation (up to 48 hours)'" />
          </tidy-row>
        </tidy-alert>

        <tidy-row class="extra-top-padding">
          <tidy-button
            [text]="isSaving ? 'Saving...' : 'Save Domain Settings'"
            [action]="saveDomain"
            class="primary"
            [disabled]="isSaving" />
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row>
          <tidy-text [header]="'Quick Actions'" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-button
            [text]="'Edit Site'"
            [action]="openEditor"
            class="primary" />
          <tidy-button
            [text]="'Preview Site'"
            [action]="openPreview"
            class="secondary" />
        </tidy-row>
      </tidy-card>

      <tidy-button
        [text]="'Complete Step'"
        [action]="completeStep"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
